/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Unpublished_HintInputs */

const cs_portals_unpublished_hint = /** @type {(inputs: Portals_Unpublished_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitost není publikovaná na webu — to nebrání zapnutí portálů (web ≠ portál).`)
};

const en_portals_unpublished_hint = /** @type {(inputs: Portals_Unpublished_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing is unpublished on the website — that does not block portal enable (website ≠ portal).`)
};

/**
* | output |
* | --- |
* | "Listing is unpublished on the website — that does not block portal enable (website ≠ portal)." |
*
* @param {Portals_Unpublished_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_unpublished_hint = /** @type {((inputs?: Portals_Unpublished_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Unpublished_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_unpublished_hint(inputs)
	return cs_portals_unpublished_hint(inputs)
});